<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form [formGroup]="CreateEmployeeLogin">
  <div class="accordion-class">
    <h5>Create Employee Login</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <div class="first_row">
        <div class="mtb mr-3 w-100">
          <mat-form-field>
            <mat-label>Emp Id</mat-label>
            <input matInput formControlName="employee_id" required />
            <mat-error>Please enter employee id</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Designation</mat-label>
            <input matInput formControlName="designation" required />
            <mat-error>Please Enter designation</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="mtb w-100">
        <mat-form-field>
          <mat-label>Full Name</mat-label>
          <input matInput formControlName="username" required />
          <mat-error>Please enter username</mat-error>
        </mat-form-field>
      </div>
      <div class="mtb w-100">
        <mat-form-field>
          <mat-label>Emp Role</mat-label>
          <input matInput formControlName="employee_role" required />
          <mat-error>Please Enter employee role</mat-error>
        </mat-form-field>
      </div>
      <div class="mtb w-100">
        <mat-form-field>
          <mat-label>Mobile Number</mat-label>
          <input
            matInput
            formControlName="mobile"
            maxlength="10"
            minlength="10"
            (keypress)="validateNumber($event)"
            required
          />
          <mat-error>Please enter valid mobile</mat-error>
        </mat-form-field>
      </div>
      <div class="mtb w-100">
        <mat-form-field>
          <mat-label>Email Id</mat-label>
          <input matInput formControlName="email" />
          <!-- <mat-error>Please Enter valid email</mat-error> -->
        </mat-form-field>
      </div>
      <div class="first_row">
        <div class="mtb mr-3 w-100">
          <mat-form-field>
            <mat-label>Create Password</mat-label>
            <input
              matInput
              formControlName="password"
              required
              type="password"
            />
            <mat-error>Please enter password</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              formControlName="confirm_password"
              required
              type="password"
            />
            <mat-error>Please Enter confirm password</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <button type="button" class="button buttonBlue" (click)="createEmployee()">
    Confirm
  </button>
</form>
